import logo from "../assets/images/logo.png"
import minister1 from "../assets/images/minister1.png"
import minister2 from "../assets/images/minister2.png"
import backgroundForet from "../assets/images/foretImage.jpeg"
import Flag_of_Cameroon from "../assets/images/Flag_of_Cameroon.png"

export default {
    logo,
    minister1,
    minister2,
    backgroundForet,
    Flag_of_Cameroon
}